// libraries
import * as React from "react";
// util
import {
  getAbsoluteDate,
  getAbsoluteDateTime,
} from "@clockwise/client-commons/src/util/format-time";
import { ZonedMoment } from "@clockwise/web-commons/src/util/time-zone.util";
// material-ui
import { AccessTime } from "@clockwise/design-system/icons";

interface IProps {
  startTime: ZonedMoment;
  endTime: ZonedMoment;
  unemphasized?: boolean;
  isAllDay?: boolean;
  calendarId?: string;
}
export const EventSummaryTime = ({ startTime, endTime, unemphasized, isAllDay }: IProps) => {
  /**
   * All day events have an end time of midnight on the next day, so we back it up to the previous day.
   * i.e. An all day event for Nov 1st will have an end time of midnight on Nov 2nd.
   */
  const endTimeAdjusted = endTime.clone().subtract(1, "minutes");
  const isSingleDay = startTime.isSame(endTimeAdjusted, "days");

  const formattedDate = isAllDay
    ? getAbsoluteDate(startTime, isSingleDay ? undefined : endTimeAdjusted, true)
    : getAbsoluteDateTime(startTime, endTime);

  return (
    <div className="cw-flex cw-items-center cw-py-1 cw-gap-2">
      <AccessTime className="cw-h-5 cw-w-5 cw-flex-shrink-0" />
      <div className={unemphasized ? "cw-body-base" : "cw-body-sm"}>{formattedDate}</div>
    </div>
  );
};
